export default __webpack_public_path__ + "static/media/element_7.040a9971.webp";